import { render } from "./BloodDonation.vue?vue&type=template&id=b0cc5f4a"
import script from "./BloodDonation.vue?vue&type=script&lang=js"
export * from "./BloodDonation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__